import type { ScriptData } from '@/components/platform/types'

export function extractScriptNodeText(node: unknown): string {
  if (node == null) return ''
  if (typeof node === 'string') return node
  if (typeof node === 'object' && node !== null) {
    const rec = node as { _text?: unknown; _cdata?: unknown }
    if ('_text' in rec) return String(rec._text ?? '')
    if ('_cdata' in rec) return String(rec._cdata ?? '')
  }
  return ''
}

export function pickElementEventScript(element: unknown, eventName: string): string | undefined {
  if (!element || typeof element !== 'object') return undefined
  const el = element as Record<string, unknown>
  const fromTag = extractScriptNodeText(el[eventName]).trim()
  if (fromTag) return fromTag
  const fromEventNs = extractScriptNodeText(el[`event.${eventName}`]).trim()
  return fromEventNs || undefined
}

export function pickElementEventScriptNode(
  element: unknown,
  eventName: string,
): ScriptData | undefined {
  if (!element || typeof element !== 'object') return undefined
  const el = element as Record<string, unknown>
  const candidates = [el[eventName], el[`event.${eventName}`]]
  const node = candidates.find(
    (candidate) =>
      candidate != null &&
      typeof candidate === 'object' &&
      extractScriptNodeText(candidate).trim() !== '',
  )
  return node as ScriptData | undefined
}
